/*
  MIMOYA — chargement des vidéos à l'approche.
  Utilisé par les sections mimoya-steps et mimoya-mechanism (réglage « Charger les vidéos
  à l'approche »). Fichier ajouté hors référentiel FullStack : survit aux mises à jour.

  Chaque <video data-mimoya-lazy> garde l'adresse de son MP4 dans <source data-src>
  et celle de son image d'attente dans data-poster (posée à l'approche, pas à l'ouverture).
  - La vidéo commence à se télécharger quand le visiteur arrive à environ un écran d'elle.
  - Elle démarre (muette, en boucle) juste avant d'entrer à l'écran.
  - Elle se met en pause quand elle sort de l'écran et reprend au retour.
  En attendant, l'image d'attente (poster) de la vidéo est affichée.
*/
(function () {
  if (window.mimoyaLazyVideo) {
    window.mimoyaLazyVideo.scan(document);
    return;
  }

  var loadObserver = null;
  var playObserver = null;

  function load(video) {
    if (video.dataset.mimoyaLoaded) return;
    video.dataset.mimoyaLoaded = 'true';
    // Perf : l'image d'attente (data-poster) n'est posée qu'à l'approche, comme la vidéo.
    if (video.dataset.poster && !video.getAttribute('poster')) {
      video.setAttribute('poster', video.dataset.poster);
    }
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
    }
    video.preload = 'auto';
    video.load();
  }

  function play(video) {
    load(video);
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
  }

  function scan(root) {
    var videos = (root || document).querySelectorAll('video[data-mimoya-lazy]');
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      if (video.dataset.mimoyaWatched) continue;
      video.dataset.mimoyaWatched = 'true';
      if (!loadObserver) {
        play(video);
        continue;
      }
      loadObserver.observe(video);
      playObserver.observe(video);
    }
  }

  if ('IntersectionObserver' in window) {
    // Téléchargement : environ un écran avant que la vidéo n'apparaisse. Toutes les
    // vidéos de la même section partent ensemble : les cartes d'un carrousel mobile
    // encore hors écran sont donc prêtes avant que le visiteur ne les fasse défiler.
    loadObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var group = entry.target.closest('.shopify-section') || entry.target.parentNode;
          var siblings = group.querySelectorAll('video[data-mimoya-lazy]');
          for (var i = 0; i < siblings.length; i++) {
            load(siblings[i]);
            loadObserver.unobserve(siblings[i]);
          }
        });
      },
      { rootMargin: '100% 0px' }
    );

    // Lecture : un peu avant l'entrée à l'écran ; pause dès qu'elle en sort.
    playObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            play(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '20% 0px' }
    );
  }

  window.mimoyaLazyVideo = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Éditeur de thème : une section rechargée doit être réobservée.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
